import React from 'react';
import classNames from 'classnames';
import { StarIcon } from 'icons';
import Image from 'next/image';

import SaveCourse from './save-course';

interface IProps {
  image?: string;
  id?: number;
  name?: string;
  rating?: number;
  saved?: boolean;
}

const CourseImage: React.FC<IProps> = ({ image, name, rating, saved, id }) => {
  const hasImage = Boolean(image?.trim());

  return (
    <div
      className={classNames('max-h-35 min-h-35 relative w-full overflow-hidden rounded-t-lg', {
        'flex items-center justify-center bg-gray-100': !hasImage
      })}
    >
      {rating && (
        <div className="absolute -left-2 top-0 z-10 flex h-5 items-center gap-1 rounded-br-lg bg-white px-1 pl-3 text-sm text-xs">
          <span>
            <StarIcon color="text-yellow-300" size="14" />
          </span>
          {rating}
        </div>
      )}
      <SaveCourse isSaved={saved} teacherCourseId={id} />
      {hasImage ? (
        <Image
          fill
          className="rounded-t-xl object-cover"
          src={image?.trimEnd() || '/images/default-no-image.webp'}
          alt={name || 'Course'}
          title="Kursni tasvirlovchi rasmi"
        />
      ) : (
        <Image
          width={70}
          height={70}
          className="object-cover"
          src="/images/default-no-image.webp"
          alt={name || 'Course'}
          title="Kursni tasvirlovchi rasmi"
        />
      )}
    </div>
  );
};

export default CourseImage;
